// extracted by mini-css-extract-plugin
module.exports = {"title1":"ForgotPasswordSent_title1__3_NSY","title2":"ForgotPasswordSent_title2__3YbFW","link":"ForgotPasswordSent_link__3SEh-"};